import { useSelector } from 'react-redux';
import { selectFooterConfiguration } from '../../redux/features/configuration/configuration.slice';

export function useConfigurableFooter() {
  const footerConfiguration = useSelector(state => selectFooterConfiguration(state));
  const parsedFooterConfiguration = footerConfiguration.map((configuration) => {
    const links = Object.keys(configuration.links || {}).map(key => ({
      href: configuration.links[key].href,
      label: configuration.links[key].label,
      icon: configuration.links[key].icon,
      i18nHrefKey: configuration.links[key].i18nHrefKey,
    }));

    return {
      label: configuration.label,
      layout: configuration.layout,
      links,
    };
  });

  return { parsedFooterConfiguration };
}
